<template>
    <div>
        <search v-model="search" @search="fetchData" placeholder="Search by course name..."/>
        <div class="row mb-4">
            <div class="col">
                <button class="btn btn-sm btn-primary float-right" @click="syncForeup">
                    <i class="fas fa-sync mr-2"></i>
                    Sync
                </button>
            </div>
        </div>
        <modal ref="modal" size="lg">
            <template slot="title">Link with {{course.course_name}} with a location</template>

            <div class="form-group">
                <label for="customer">Customer</label>
                <multiselect
                        id="customer"
                        :options="customers"
                        track-by="id" label="name"
                        v-model="customer"
                        placeholder="Type to search"
                        :searchable="true"
                        :loading="customerLoading"
                        :options-limit="10"
                        :limit="3"
                        @search-change="fetchCustomers"
                ></multiselect>
            </div>

            <div class="form-group">
                <label for="location">Location</label>
                <multiselect
                        id="location"
                        :options="locations"
                        track-by="id" label="name"
                        v-model="location"
                        placeholder="Type to search"
                        :searchable="true"
                        :loading="locationLoading"
                        :options-limit="10"
                        :limit="3"
                        :disabled="customer === null"
                        @search-change="fetchLocations"
                        :class="{'is-invalid': form.errors.get('location_id')}"
                ></multiselect>
                <span class="invalid-feedback" v-if="form.errors.has('location_id')">
                    {{ form.errors.get('location_id') }}
                </span>
            </div>

            <template slot="footer">
                <button class="btn btn-default" type='button' data-dismiss='modal'>
                    Cancel
                </button>
                <button class="btn btn-primary" @click="link">Link</button>
            </template>

        </modal>
        <card>
            <card-header>
                Foreup Integrations
            </card-header>
            <card-body class="pt-0" v-if="loading">
                <card-spinner size="large" style="height: 240px;"/>
            </card-body>
            <card-body class="p-0" v-else>
                <table class="table mb-0 table-hover">
                    <thead>
                    <tr>
                        <th>Course</th>
                        <th>City</th>
                        <th>State</th>
                        <th>Company</th>
                        <th>Location</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in integrations" :key="`foreup-${index}`">
                        <td>{{ item.course_name }}</td>
                        <td>{{ item.course_city }}</td>
                        <td>{{ item.course_state }}</td>
                        <td>{{ item.location.team }}</td>
                        <td>{{ item.location.name }}</td>
                        <td>
                            <button class="btn btn-danger btn-sm" @click="unlink(item)" v-if="item.location.id">
                                Unlink
                            </button>

                            <button class="btn btn-primary btn-sm" @click="linkCourse(item)" v-else>
                                Link
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </card-body>
        </card>
    </div>
</template>

<script>

    import Form from "../../utils/Form";

    export default {
        data: () => ({
            integrations   : [],
            course         : {},
            loading        : true,
            search         : null,
            form           : new Form({}),
            customer       : null,
            customers      : [],
            customerLoading: false,
            location       : null,
            locations      : [],
            locationLoading: false
        }),

        created() {
            this.fetchData();
        },

        methods: {
            async fetchCustomers(query) {
                this.customerLoading = true;
                let params           = {search: this.search};
                let {data}           = await this.$http.get(this.$laroute.route('api.teams.light'), {params});
                this.customers       = data;
                this.customerLoading = false;
            },

            async fetchLocations(query) {
                this.locationLoading = true;
                let params           = {search: this.search, team_id: this.customer.id};
                let {data}           = await this.$http.get(this.$laroute.route('api.locations.light'), {params});
                this.locations       = data;
                this.locationLoading = false;
            },

            async fetchData() {
                this.loading      = true;
                let params        = {search: this.search};
                let {data}        = await this.$http.get(this.$laroute.route('api.foreup.index'), {params});
                this.loading      = false;
                this.integrations = data.data;
            },

            linkCourse(foreup) {
                this.course   = foreup;
                this.location = null;
                this.customer = null;
                this.form     = new Form({location_id: null, foreup_id: foreup.id});
                this.$refs.modal.open();
            },

            async syncForeup() {
                this.loading = true;
                await this.$http.get(this.$laroute.route('api.foreup.sync'));
                await this.fetchData();
                this.loading = false;
            },

            async link() {
                this.form.location_id = this.location.id;
                await this.form.post(this.$laroute.route('api.foreup.link'));
                this.fetchData();
                this.$refs.modal.close();
            },

            async unlink(foreup) {
                let uri = this.$laroute.route('api.foreup.unlink', {foreup: foreup.id, location: foreup.location.id});
                await this.$http.put(uri);
                this.fetchData();
            }
        },
    };
</script>
